// Patrón reutilizable de validación visual de formularios (design system).
// Uso: const { errors, validate, clearField } = useFieldErrors();
//   - validate(rules): rules = { campo: mensajeTraducido | null } → marca en
//     rojo los campos con mensaje, hace scroll + focus al PRIMER error y
//     devuelve false; si no hay errores devuelve true.
//   - Cada campo se envuelve con data-field="<campo>" para el scroll/focus.
//   - clearField(campo) al editar: el error desaparece en cuanto se corrige.
import { useCallback, useState } from "react";

export const errorInputCls =
  "border-red-500 focus-visible:ring-red-500/25 focus-visible:border-red-500";

export function useFieldErrors() {
  const [errors, setErrors] = useState({});

  const clearField = useCallback((field) => {
    setErrors((e) => {
      if (!e[field]) return e;
      const next = { ...e };
      delete next[field];
      return next;
    });
  }, []);

  const validate = useCallback((rules) => {
    const errs = {};
    for (const [field, message] of Object.entries(rules)) {
      if (message) errs[field] = message;
    }
    setErrors(errs);
    const first = Object.keys(errs)[0];
    if (first) {
      requestAnimationFrame(() => {
        const wrapper = document.querySelector(`[data-field="${first}"]`);
        if (!wrapper) return;
        wrapper.scrollIntoView({ behavior: "smooth", block: "center" });
        wrapper.querySelector("input, textarea, select, button, [role='combobox']")
          ?.focus({ preventScroll: true });
      });
      return false;
    }
    return true;
  }, []);

  return { errors, validate, clearField, setErrors };
}

export const FieldError = ({ field, message }) =>
  message ? (
    <p role="alert" className="text-xs text-red-600 leading-snug"
      data-testid={`field-error-${field}`}>
      {message}
    </p>
  ) : null;
